import { render, staticRenderFns } from "./waterCharge.vue?vue&type=template&id=5c398dcd&"
import script from "./waterCharge.vue?vue&type=script&lang=js&"
export * from "./waterCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports